import { Select, Space, Card } from 'antd';
import React from 'react';

const mockValues = [
  'Metis',
  'Adrastea',
  'Amalthea',
  'Thebe',
  'Europa',
  'Callisto',
  'Leda',
  'Themisto',
  'Lysithea',
  'Helike',
];
const options = mockValues.map((value) => {
  return {
    value: value.toLowerCase(),
    label: value,
  };
});
const defaultValue = mockValues[Math.floor(Math.random() * mockValues.length)];

function Selects() {
  return (
    <Card title="Select">
      <Space>
        <Select options={options} defaultValue={defaultValue} style={{ minWidth: 100 }} />
        <Select options={options} defaultValue={defaultValue} disabled style={{ minWidth: 100 }} />
        <Select
          options={options}
          defaultValue={defaultValue}
          bordered={false}
          style={{ minWidth: 100 }}
        />
        <Select
          options={options}
          defaultValue={defaultValue}
          bordered={false}
          disabled
          style={{ minWidth: 100 }}
        />
        <Select
          options={options}
          defaultValue={defaultValue}
          bordered={false}
          showSearch
          style={{ minWidth: 100 }}
        />
        <Select
          options={options}
          defaultValue={defaultValue}
          showSearch
          mode="tags"
          style={{ minWidth: 100 }}
        />
      </Space>
    </Card>
  );
}

export default Selects;
